import React from "react";

import { Image } from "@src/components/Image";
import { useDispatch, useSelector } from "react-redux";
import { postLikeAction } from "../../store/actions";
import { useRouter } from "@src/lib/router";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";
import { newWebEngage } from "@src/utils/webEngageEvent";

import LikedIcon from "@src/components/AccentIcons/LikeIcon/index.jsx";

const LikeButton = ({ value }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  // REDUX STATES
  const likeCount = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.likes?.value
  );
  const isLiked = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isLiked
  );

  const handleLikeClick = () => {
    if (!isLiked) {
      newWebEngage("course_like_click", {
        action: "Stu Like Course"
      });
      hitHapticFeedback();
      animationRef.current = true;
    }
    dispatch(
      postLikeAction({
        courseId: router?.query?.courseId,
        status: isLiked ? 0 : 1,
      })
    );
    timerRef.current = setTimeout(() => {
      animationRef.current = false;
    }, 1000);
  };

  const timerRef = React.useRef(null);
  const animationRef = React.useRef(false);

  React.useEffect(() => {
    return () => {
      animationRef.current = false;
      clearTimeout(timerRef?.current);
    };
  }, []);

  return (
    likeCount ? <>
      <div className="like--div" onClick={() => handleLikeClick()}>
        {isLiked ? (
          <LikedIcon
            className={animationRef?.current ? "like--div--img--2" : ""}
          />
        ) : (
          <Image
            src={getAwsAssets("BeforeLike.svg", "content")}
            alt="like"
            className={isLiked ? "like--div--img" : "like--div--img"}
            width={24}
            height={24}
          />
        )}
      </div>
      <span className={isLiked ? "like--text done" : "like--text"}>
        {likeCount}
      </span>
    </> : null
  );
};

export default React.memo(LikeButton);
